import axios from "axios";
import { api } from "../config";
import Cookies from 'js-cookie';
import { toast } from "react-toastify";
import { t } from "i18next";

let cachedIp = null;

async function getClientIp() {
  if (cachedIp) return cachedIp; 
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    cachedIp = data.ip;
    return data.ip;  
  } catch (error) {
    cachedIp = "127.0.0.1";
    return cachedIp;
  }
}


// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// axios.defaults.timeout = 15 * 60 * 1000;

// content type
// const token = Cookies.get('authorizationToken') ?  JSON.parse(Cookies.get('authorizationToken')) : null;

// if (token)
//   axios.defaults.headers.common["Authorization"] = "Bearer " + token;

//   axios.defaults.headers.common["environment"] = process.env.REACT_APP_ENVIRONMENT || "Dev";

//Localization API 
const localizationApi = [
  "/GetTranslations?language=en",
  "/GetTranslations?language=ar",
  "/GetLocalization?language=en",
  "/GetLocalization?language=ar",
  "/AddLocalization",
  "/UpdateLocalization",
  "/DeleteLocalization"
]


const setHeaders = async (config) => {
  
  const token = Cookies.get('authorization') ?  Cookies.get('authorization') : null;
  // const clientIp = await getClientIp();
  config.headers["authorization"] = token;
  config.headers["langid"] = localStorage.getItem("langId") || 1;
  // config.headers["X-Forwarded-For"] = clientIp; 
  config.headers["pathName"] = window.location.pathname;
  // config.headers["refreshtoken"] = config.url?.includes("/Login")
  // ? Cookies.get("customToken") : null;
  // config.headers["environment"] = api.ENVIRONMENT || "Dev";
  config.headers["environment"] = localizationApi.includes(config.url)
    ? "Prod" : api.ENVIRONMENT || "Dev";

  return config;
};

   
axios.interceptors.request.use(setHeaders);



let isRefreshing = false;
let failedQueue = [];
 
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
 
  failedQueue = [];
};

// Response interceptor
axios.interceptors.response.use(
  response => (response.data ? response.data : response),
  async error => {
    const originalRequest = error.config;
    

    // if (error?.response?.status === 401 && !originalRequest._retry) {
    //   if (isRefreshing) {
    //     return new Promise(function (resolve, reject) {
    //       failedQueue.push({ resolve, reject });
    //     })
    //       .then(token => {
    //         originalRequest.headers['authorization'] = token;
    //         return axios(originalRequest);
    //       })
    //       .catch(err => Promise.reject(err));
    //   }

    //   originalRequest._retry = true;
    //   isRefreshing = true;

    //   try {
    //     // Call your refresh token API here
    //     toast.info(t("Refreshing token..."));
    //     const refreshResponse = await axios.post('/Login');

    //     const data = refreshResponse.data;
    //     Cookies.set("authorization", data.authToken);
    //     Cookies.set("customToken", data.refreshToken);
    //     axios.defaults.headers.common['authorization'] = data.authToken;
    //     // processQueue(null, data.authToken);
    //     // originalRequest.headers['authorization'] = data.authToken;
    //     // setTimeout(() => {
    //     //   window.location.reload();
    //     //   // return axios(originalRequest);
    //     // }, 100)
    //   } catch (refreshError) {
        
    //     processQueue(refreshError, null);
    //     Cookies.remove("authorization");
    //     Cookies.remove("customToken");
    //     Cookies.remove("authUser");
    //     window.location.href = '/login';
    //     return Promise.reject(refreshError);
    //   } finally {
    //     isRefreshing = false;
    //   }
    // }
    
    const messageMap = {
      401: 'Unauthorized access',
      404: 'Sorry! the data you are looking for could not be found',
      500: 'Internal Server Error',
      409: 'Already exists',
    };
    
    const status = error?.response?.status;
    const message = error?.response?.data?.message || messageMap[status] || error?.message || "An unexpected error occurred";


    // Handle 403 Forbidden error
    if (status === 403) {
      toast.error(t("Access denied. You do not have permission to access this Page."));

      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1000);
    }else if (status === 409) {
      toast.error(t(message));
    }else if (status === 400) {
      toast.error(t(message));
    }else if (status === 498) {
      window.location.href = '/login';
        Cookies.remove("authorization");
        Cookies.remove("customToken");
        Cookies.remove("authUser");
      toast.warn(t(message));
    }
        
    return Promise.reject(status === 401 ? error : message);
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["authorization"] = token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data, headers={}) => {
    return axios.post(url, data, headers);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };